import { Controller } from 'stimulus';

export default class extends Controller {

  static targets = ['activiteRow', "selection", "inputsRow", "risqueField"]

  handleSelect() {
    const selection = event.target.value;
    if (selection === "" || selection === 'all') {
      this.resetFilter();
    } else if (selection === 'select') {
      this.filterActivites(this.selectionTarget.value);
    } else {
      this.filterActivites(event.target.value);
    }
  }

  resetFilter() {
    this.activiteRowTargets.forEach(activite => {
      activite.classList.remove('d-none');
    })
  }

  addRisqueField() {
    this.inputsRowTarget.insertAdjacentHTML('beforeend', this.risqueFieldTarget.outerHTML);
  }

  filterActivites(selectedRegroupementId) {
    this.activiteRowTargets.forEach(activite => {
      const regroupementId = activite.dataset.regroupementId;
      if (regroupementId === selectedRegroupementId) {
        activite.classList.remove('d-none');
      } else {
        activite.classList.add('d-none');
      }
    })
  }
}
